/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DragDropDirective as ɵa} from './lib/directives/drag-drop.directive';